export const SHORT_DATE_FORMAT = 'yyyy-MM-dd';
export const READABLE_SHORT_DATE_FORMAT = 'dd MMM yyyy';
export const SEARCH_DEBOUNCE_TIME = 300;
export const FALLBACK_LANGUAGE = 'en';
